// Info: Boilerplate library. Contains Functions for Outgoing HTTP(s) requests (For browsers only and not for NodeJS)
// TODO: multipart requests
import $ from "jquery";
import WebStorage from "./web_storage";
import { AUTH_TOKEN_KEY } from "./web_storage_keys";

function isPayoutInvoicePdfUrl(url) {
  return typeof url === "string" && url.includes("/generate-payout-invoice-pdf");
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;
  let binary = "";
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }
  return btoa(binary);
}

function looksLikePdfArrayBuffer(buffer) {
  if (!(buffer instanceof ArrayBuffer) || buffer.byteLength < 4) return false;
  const header = String.fromCharCode(...new Uint8Array(buffer, 0, 4));
  return header === "%PDF";
}

function decodeArrayBufferAsJson(buffer) {
  if (!(buffer instanceof ArrayBuffer) || buffer.byteLength === 0) {
    return null;
  }
  try {
    const text = new TextDecoder().decode(buffer);
    if (!text.trim().startsWith("{") && !text.trim().startsWith("[")) {
      return null;
    }
    return JSON.parse(text);
  } catch (_) {
    return null;
  }
}

function normalizePdfBinaryResponse(data, xhr) {
  const buffer =
    data instanceof ArrayBuffer
      ? data
      : xhr?.response instanceof ArrayBuffer
        ? xhr.response
        : null;

  if (!buffer) {
    return null;
  }

  if (looksLikePdfArrayBuffer(buffer)) {
    return {
      success: true,
      pdf_base64: arrayBufferToBase64(buffer),
      content_type: "application/pdf",
    };
  }

  return decodeArrayBufferAsJson(buffer);
}

///////////////////////////Public Functions START//////////////////////////////
const HttpBrowser = {
  // Public functions accessible by other modules

  /********************************************************************
	Get JSON-Data from remote server using http(s) protocal.

  @param {reference} jquery_instance - Request Jquery Instance object reference
  @param {Function} cb - Callback function to be invoked once async execution of this function is finished

	@param {String} url - Full URL without protocal
	@param {String} method - ENUM-String for request method (GET | POST | .. )
	@param {Map} params - (Optional) Params to be sent with this request
	@param {String} request_content_type - (Optional) Request Body data type. Default: x-www-form-urlencoded ('json' | 'x-www-form-urlencoded' | 'multipart')

  @return - Thru Callback

  @callback(error, response_status,  response_data) - Request Callback
	* @callback {Integer} response_status - HTTP Response code from server
	* @callback {Map} response_headers - Return headers from response in Key-value. All keys are converted into lower-case.
	* @callback {ArrayBuffer | String | Object | Blob | Document | Stream} response_data - Return data as per response type.
	*********************************************************************/
  fetch: function (cb, url, method, params, request_content_type, auth) {
    // Fetch JSON data from URL

    // If the caller marked this request as requiring auth but token is missing,
    // do an automatic logout/redirect to login.
    try {
      var token = WebStorage.getDataFromWebStorage(AUTH_TOKEN_KEY);
    } catch (e) {
      var token = null;
    }

    if (auth && !token) {
      // Clear any stale data and force redirect to login
      try {
        WebStorage.clearDataFromWebStorage(AUTH_TOKEN_KEY);
      } catch (e) {}
      window.sessionStorage.removeItem("authenticated");
      // redirect to login page
      window.location.href = "/login";
      return;
    }

    var headers = {};
    if (token) {
      headers["Authorization"] = "Bearer " + token;
    }

    const expectsPdfBinary = isPayoutInvoicePdfUrl(url);
    let requestUrl = url;
    if (method.toUpperCase() === "GET" && params) {
      requestUrl +=
        (requestUrl.includes("?") ? "&" : "?") + $.param(params);
    }

    $.ajax({
      url: requestUrl,
      type: method,
      data: method.toUpperCase() === "GET" ? undefined : params,
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
        ...(expectsPdfBinary ? { responseType: "arraybuffer" } : {}),
      },
      contentType: "application/x-www-form-urlencoded",
      headers: headers,
      success: function (
        data, // Response data
        text_status, // Returns a DOMString containing the response string returned by the HTTP server
        xhr // XHR response object
      ) {
        if (expectsPdfBinary) {
          const normalized = normalizePdfBinaryResponse(data, xhr);
          if (normalized) {
            return cb(null, normalized, xhr.status);
          }
        }

        cb(
          null, // No error
          data && !(data instanceof ArrayBuffer) ? data : null,
          xhr.status
        );
      },
      error: function (
        error, // XHR response object
        text_status, // Returns a DOMString containing the response string returned by the HTTP server
        //  Possible values for the second argument (besides null) are "timeout", "error", "abort", and "parsererror".
        xhr // When an HTTP error occurs, error receives the textual portion of the HTTP status,
      ) {
        // If unauthorized, clear token and redirect to login
        try {
          if (xhr && xhr.status === 401) {
            WebStorage.clearDataFromWebStorage(AUTH_TOKEN_KEY);
            window.sessionStorage.removeItem("authenticated");
            window.location.href = "/login";
            return cb(error, null, xhr.status);
          }
        } catch (e) {}

        if (expectsPdfBinary) {
          const normalized = normalizePdfBinaryResponse(null, xhr);
          if (normalized) {
            return cb(null, normalized, xhr.status);
          }
        }

        cb(
          error, // No error,
          xhr?.responseJSON || null,
          xhr.status,
          null,
          null // Null as data in case of no response-body);
        );
      },
    });
  },
}; ///////////////////////////Public Functions END//////////////////////////////
export default HttpBrowser;

//////////////////////////Private Functions START//////////////////////////////
// var _HttpBrowser = { // Private functions accessible within this modules only
//
//
// };
//////////////////////////Private Functions END//////////////////////////////
